import { getStatusColor, getStatusForeColor } from '@/utils';
import {
  AccountBalance as AccountBalanceIcon,
  Business as BusinessIcon,
  CarRepair as CarRepairIcon,
  LocalHospital as LocalHospitalIcon,
  LocalPolice as LocalPoliceIcon,
  School as SchoolIcon,
} from '@mui/icons-material';
import { Avatar, Box, ListItemButton, ListItemText } from '@mui/material';

function Icon({ type }) {
  switch (type) {
    case 'Base':
      return <BusinessIcon />;
    case 'Court':
      return <AccountBalanceIcon />;
    case 'Hospital':
      return <LocalHospitalIcon />;
    case 'Police Station':
      return <LocalPoliceIcon />;
    case 'School':
      return <SchoolIcon />;
    case 'Workshop':
      return <CarRepairIcon />;
    case 'Boundary':
    case 'Force Boundary':
    case 'Local Authority':
    case 'Region':
    case 'Sector':
    case 'Ward':
    default:
      return <BusinessIcon />;
  }
}

export function LocationListItem({ item, feature, ...props }) {
  const primary = feature.properties.name;
  const secondary = feature.properties.subtype;

  return (
    <ListItemButton
      {...props}
      dense
      disableGutters
      sx={
        item
          ? {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: `${item.size}px`,
              transform: `translateY(${item.start}px)`,
              px: 1,
            }
          : { px: 1 }
      }
      // component={Link}
      // to={'.'}
    >
      <Box sx={{ pr: 1 }}>
        <Avatar
          sx={{
            color: getStatusForeColor('default'),
            bgcolor: getStatusColor('default'),
            borderColor: getStatusForeColor(feature.properties?.status),
            borderWidth: 2,
            borderStyle: 'solid',
          }}
        >
          <Icon type={feature.properties.type} />
        </Avatar>
      </Box>
      <ListItemText
        primary={primary}
        secondary={secondary}
        slotProps={{
          primary: { noWrap: true },
          secondary: { noWrap: true },
        }}
      />
    </ListItemButton>
  );
}
